// Panel RMA chodzi na browser history, wiec parametry (?code=...) siedza w
// location.search. W panelach na hash history siedza za '#'. Obslugujemy oba,
// zeby setQueries nie kasowalo parametrow, ktorych nie widzi.
export function getQueries(){
  const hashSplit = window.location.hash.split('?')
  const queryString = hashSplit.length > 1 ? hashSplit.pop() : window.location.search
  const params = new URLSearchParams(queryString)
  return Array.from(params.keys()).reduce(
    (queries, key) => ({...queries, [key]: params.get(key)}),
    {}
  )
}

export function setQueries(queries){
  const new_queries = {
    ...getQueries(),
    ...queries
  }
  const params = new URLSearchParams()
  Object.keys(new_queries).forEach((key) => {
    if (typeof new_queries[key] !== 'undefined'){
      params.append(key, new_queries[key])
    }
  })
  const search = params.toString()
  return search ? '?' + search : ''
}

// Cel przekierowania zachowujacy biezacy query string (np. ?code=... z ERP-a).
export function keepQuery(pathname){
  return {
    pathname,
    search: window.location.search
  }
}

export function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode('0x' + p1)));
}

export function isDark(color) {
    // Variables for red, green, blue values
    var r, g, b, hsp;

    // If hex --> Convert it to RGB: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(
    color.length < 5 && /./g, '$&$&'))

    r = color >> 16
    g = color >> 8 & 255
    b = color & 255

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
    )

    // Using the HSP value, determine whether the color is light or dark
    if (hsp>137.5) { return false }
    else { return true }
}
